if (document.querySelector('.splide_grid')) {
  document.querySelectorAll('.splide_grid').forEach(function (grid) {
    const customPagination = grid.querySelector('.custom_pagination');

    if (grid.classList.contains('blog-grid')) {
      console.log('blog grid');
      var splide = new Splide(grid, {
        perPage: 3,
        gap: '40px',
        arrows: false,
        pagination: true,
        speed: 600,
        breakpoints: {
          1024: {
            perPage: 3,
          },
          768: {
            perPage: 2,
          },
          600: {
            perPage: 1,
          },
        },
      });
    } else {
      var splide = new Splide(grid, {
        perPage: 4,
        gap: '8px',
        arrows: false,
        pagination: true,
        speed: 600,
        breakpoints: {
          1024: {
            perPage: 3,
          },
          768: {
            perPage: 2,
          },
          600: {
            perPage: 1,
          },
        },
      });
    }

    splide.on('mounted move', () => {
      customPagination.innerHTML = '';
      const totalPages = splide.Components.Controller.getEnd() + 1;

      if (totalPages == 1) {
        grid.querySelector('.pagination_controls').classList.add('hidden');
      }

      for (let i = 0; i < totalPages; i++) {
        const dot = document.createElement('button');
        dot.classList.add('splide__pagination__page');
        if (i === splide.index) {
          dot.classList.add('is-active');
        }
        dot.addEventListener('click', () => {
          splide.go(i);
        });
        customPagination.appendChild(dot);
      }

      const progressBarFill = grid.querySelector('.progress_bar_fill');
      const progress = (splide.index / splide.Components.Controller.getEnd()) * 100;
      progressBarFill.style.width = progress + '%';
    });

    splide.mount();

    const prevButton = grid.querySelector('.prev_button');
    const nextButton = grid.querySelector('.next_button');

    if (prevButton) {
      prevButton.addEventListener('click', () => splide.go('-1'));
    }
    if (nextButton) {
      nextButton.addEventListener('click', () => splide.go('+1'));
    }
  });
}

if (document.querySelector('#partner-logos')) {
  let splide = new Splide('#partner-logos', {
    type: 'loop',
    drag: 'free',
    // focus: 'center',
    pagination: false,
    arrows: false,
    gap: '60px',
    autoWidth: true,
    autoScroll: {
      speed: 0.6,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
  });

  splide.mount(window.splide.Extensions);
}

if (document.querySelector('#scrolling-banner')) {
  let splide = new Splide('#scrolling-banner', {
    type: 'loop',
    drag: 'free',
    pagination: false,
    arrows: false,
    gap: '20px',
    focus: 'center',
    autoWidth: true,
    autoScroll: {
      speed: 0.8,
      pauseOnHover: false,
      pauseOnFocus: false,
    },
  });

  splide.mount(window.splide.Extensions);
}

if (document.querySelector('#also-like-collections-splider')) {
  let splide = new Splide('#also-like-collections-splider', {
    pagination: false,
    arrows: false,
    gap: '32px',
    // autoWidth: true,
    trimSpace: false,
  });

  let leftButton = document.getElementById('also-like-left-arrow');
  let rightButton = document.getElementById('also-like-right-arrow');

  splide.on('mounted move', function () {
    if (splide.index === 0) {
      leftButton.classList.add('disabled');
    } else {
      leftButton.classList.remove('disabled');
    }

    if (splide.index === splide.Components.Controller.getEnd()) {
      rightButton.classList.add('disabled');
      document.querySelector('.blurred_overlay').classList.add('hidden');
    } else {
      rightButton.classList.remove('disabled');
      document.querySelector('.blurred_overlay').classList.remove('hidden');
    }
  });

  leftButton.addEventListener('click', function () {
    splide.go('-1');
  });

  rightButton.addEventListener('click', function () {
    splide.go('+1');
  });

  splide.mount();
}

if (document.querySelector('#product_gallery')) {
  let splide = new Splide('#product_gallery', {
    type: 'loop',
    perPage: 1,
    pagination: false,
    arrows: false,
    gap: '0px',
    width: '100%',
  });

  splide.mount();

  const thumbnails = document.querySelectorAll('.left .product__media-item');
  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => {
      const index = parseInt(thumbnail.getAttribute('thumbnail-index'));
      splide.go(index);
    });
  });

  splide.on('move', () => {
    const currentIndex = splide.index;
    thumbnails.forEach((thumbnail) => {
      thumbnail.classList.remove('active');
      const thumbIndex = parseInt(thumbnail.getAttribute('thumbnail-index'));
      if (thumbIndex === currentIndex) {
        thumbnail.classList.add('active');
      }
    });
  });
}

if (document.querySelector('#home-hero-mob')) {
  let splide = new Splide('#home-hero-mob', {
    type: 'loop',
    perPage: 1,
    pagination: true,
    arrows: false,
    gap: '0px',
    width: '100%',
  });

  splide.mount();
}
